<h2 mat-dialog-title>
	<div class="d-flex justify-content-between align-items-center w-100">
		<span>Distribution des quantités</span>
		<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal" mat-dialog-close></button>
	</div>
</h2>
<mat-dialog-content>
	<form class="tablelist-form w-100" autocomplete="off">
		<div class="table-container" style="max-height: 400px; overflow-y: auto">
			<table class="table align-middle table-striped table-hover p-0 m-0 table-nowrap table-card w-100">
				<thead>
					<tr class="bg-light text-muted sticky-header">
						<th style="width: 30%">Projet</th>
						<th style="width: 15%">Quantité</th>
						<th style="width: 10%">Demande</th>
						<th style="width: 15%">Demandeur</th>
						<th style="width: 15%">Date demande</th>
						<th style="width: 15%">Date Validation</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let dmd of distribution;">
						<td>{{ dmd.projet }}</td>
						<td>{{ dmd.qte }}</td>
						<td>{{ dmd.demande }}</td>
						<td>{{ dmd.demandeur }}</td>
						<td>{{ dmd.dateDemande | dateFormatPipe }}</td>
						<td>{{ dmd.dateValidation | dateFormatPipe }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</form>
</mat-dialog-content>
<!--<mat-dialog-actions>
	 You camn add additional actions here if needed 
</mat-dialog-actions>
-->
